import {Component} from 'react';

const CHUNK_RELOAD_KEY = 'chunk-error-reloaded';

const isChunkLoadError = error => {
    const message = String(error?.message || error || '').toLowerCase();
    return message.includes('loading chunk') || message.includes('chunkloaderror');
};

class ChunkErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error) {
        if (!isChunkLoadError(error)) {
            return;
        }

        const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';
        if (alreadyReloaded) {
            sessionStorage.removeItem(CHUNK_RELOAD_KEY);
            return;
        }

        sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
        window.location.reload();
    }

    render() {
        if (this.state.hasError) {
            return null;
        }

        return this.props.children;
    }
}

export default ChunkErrorBoundary;